module.exports = __webpack_public_path__ + "static/media/zgoda_na_leczenie_ortodontyczne.33878ee5.pdf";